import React from 'react';

import * as S from './styles';

import { withPaymentLinkContext } from './context/PaymentLinkContext';

import CardInfo from '@/components/CardInfo';
import Footer from '@/components/Footer';

import Loading from '@/components/Loading';
import ModalLoading from '@/components/ModalLoading';

import useCheckout from './checkout.hook';
import { Progress } from '@useblu/ocean-react';

const Checkout: React.FC = () => {
  const {
    navigate,
    getLinkIsLoading,
    errorRedirect,
    postIsLoading,
    CurrentStep,
    loadingPage,
  } = useCheckout();

  if (getLinkIsLoading && !errorRedirect) return <Loading />;

  if (errorRedirect) {
    navigate(errorRedirect);

    return <></>;
  }

  return (
    <S.Wrapper>
      <S.Container>
        {loadingPage ? (
          <S.LoadingContent>
            <Progress />
          </S.LoadingContent>
        ) : (
          <S.Content>
            <S.CardContainer>
              <CardInfo />
            </S.CardContainer>
            <S.FormContainer>
              <CurrentStep />
            </S.FormContainer>
          </S.Content>
        )}
      </S.Container>
      <Footer />

      <ModalLoading isOpen={postIsLoading} />
    </S.Wrapper>
  );
};

export default withPaymentLinkContext(Checkout);
